const styles = {
  container: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '20px'
  },
  headerText: {
    fontWeight: 600,
    fontSize: "18px",
    color: '#202020'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  addButton: {
    backgroundColor: '#28AA4A',
    cursor: 'pointer',
    borderRadius: '40px',
    textTransform: 'none',
  },
  filterSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '1',
    marginRight: '16px',
  },
  searchInput: {
    width: "208.03px", // Rounded to 2 decimals
    height: "30px",
    opacity: 1,
    borderRadius: "40px",
    paddingTop: "6px",
    paddingRight: "10px",
    paddingBottom: "6px",
    paddingLeft: "10px",
    gap: "3px",
    background: "#F1F1F1",
    border: "none",           // Optional: clean border
    outline: "none",          // Optional: remove blue outline on focus
  },
  sortByContainer: {
    width: "83px",
    height: "30px",
    opacity: 1,
    borderRadius: "30px",
    padding: "6px 10px",
    gap: "3px", // optional – no direct effect on Box unless used in flex
    background: "#28AA4A33",
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // center the text inside
  },
  sortByText: {
    fontWeight: 500, // Medium
    fontSize: "12px",
    color: "#28AA4A",
  },
  checkbox: {
    width: "20.75px",
    height: "19.29px",
    borderRadius: "4px",
    opacity: 1,
    padding: 0,
  },
  tableCell: {
    fontWeight: 400,          // Regular weight
    fontSize: "14px",
    color: "#878787",
  },
  tableCells: {
    opacity: 1,
    fontWeight: 400,
    fontSize: '14px',
    color: '#202020',
  },
  statusChip: {
    fontSize: '12px',
    fontWeight: 500,
    color: '#00ABF4',
    whiteSpace: 'nowrap'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '24px',
  },
  paginationBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paginationButton: {
    width: '32px',
    height: '32px',
    minWidth: 'unset',
    padding: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 500,
    '&.prev': {
      backgroundColor: '#28AA4A33',
      color: '#28AA4A',
    },
    '&.next': {
      backgroundColor: '#28AA4A',
      color: '#fff',
    },
    '&.page': {
      backgroundColor: 'transparent',
      color: '#878787',
      '&:hover': {
        backgroundColor: '#F1F1F1',
      },
      '&.active': {
        backgroundColor: '#28AA4A',
        color: '#fff',
      },
    },
  },
  ellipsis: {
    color: '#202020',
    padding: '0 4px',
  },
  rowsPerPageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    position: 'relative',
  },
  rowsPerPageText: {
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: '#202020 !important',
  },
  rowsPerPageSelect: {
    opacity: 1,
    borderRadius: '22px',
    padding: '6px 35px 6px 15px', // increased right padding to make room for icon
    gap: '10px',
    border: '1px solid #E5E5E5',
    appearance: 'none',
    fontSize: '14px',
    color: '#333',
    backgroundColor: '#fff',
    cursor: 'pointer',
  },
  selectIcon: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none', // makes the icon not interfere with select clicks
  },
};

export default styles; 